// Helpers puros de analytics do relatório (casamento de métricas por padrão de
// texto e assinatura de query string). Extraídos de RelatorioIndex.vue.

export const normalizeMetricText = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const metricMatches = (item, patterns) => {
  const text = normalizeMetricText(`${item.key || ''} ${item.label || ''}`);
  return patterns.some(pattern => text.includes(pattern));
};

export const sumMetricValueByPatterns = (metricItems, patterns) =>
  metricItems
    .filter(item => metricMatches(item, patterns))
    .reduce((sum, item) => sum + Number(item.valor || 0), 0);

export const compactQuery = query =>
  Object.fromEntries(
    Object.entries(query).filter(([, value]) => value != null && value !== '')
  );

export const querySignature = query =>
  Object.entries(query)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => `${key}:${Array.isArray(value) ? value[0] : value}`)
    .join('|');
